import { CALL_API } from 'redux-api-middleware';

import { createRequestTypes } from './utils';
import { buildOrdersUrl } from '../service/oms';
import normalizeSymbol from '../service/normalizesymbol';

export const DATA_RECEIVED = '@@orders/DATA_RECEIVED';
export const FETCH_DATA = createRequestTypes('@@orders/FETCH_DATA');

export function orderDataReceived(symbol, key, values) {
    const meta = { symbol };

    return { type: DATA_RECEIVED, key, values, meta };
}

export const requestOrderData = symbol => {
    const meta = { symbol: normalizeSymbol(symbol) };

    const [ticker, market] = symbol.split('.');

    const validMarkets = ['OSE', 'OAX', 'MERK'];

    return {
        [CALL_API]: {
            endpoint: buildOrdersUrl(ticker, market),
            method: 'GET',
            types: [
                { type: FETCH_DATA.REQUEST, meta },
                {
                    type: FETCH_DATA.SUCCESS,
                    payload: (action, state, res) => {
                        const contentType = res.headers.get('Content-Type');
                        if (contentType && ~contentType.indexOf('json')) {
                            return res.json().then(
                                json => json.rows
                            );
                        }
                        return null;
                    },
                    meta,
                },
                { type: FETCH_DATA.FAILURE, meta },
            ],
            bailout: () => !validMarkets.includes(market),
        },
    };
};



/** WEBPACK FOOTER **
 ** /src/shared/actions/orders.js
 **/